import { IRequestDto } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/dto/RequestDto';

import { IRequest } from '@r1-frontend/shared/types/IRequest';

/**
 * Список специальных предложений
 * @link https://master.spec-offer.sandbox.d2c.r-one.io/docs#/Специальные%20предложения/SpecOfferReqScopedController_getSpecOffers
 */
export const specOffers = (providerId: number, queryParams?: IRequestDto): IRequest => ({
    uri: `/api/v1/${providerId}`,
    method: 'GET',
    withAuth: true,
    withProvider: true,
    queryParams,
});
